<template>
<!--  <button @click="showCart = true" class="flex items-center group relative uppercase">-->
<!--&lt;!&ndash;    <img class="w-6 -scale-x-100" src="/img/cart.svg" alt="Cart"/>&ndash;&gt;-->

<!--    <span class="group-hover:underline">Cart-->
<!--      <span class="text-[16px]" v-if="lineItems && totalQuantity != 0">({{ totalQuantity }})</span>-->
<!--    </span>-->
<!--  </button>-->
  <div class="text-black fixed top-0 left-0 w-full h-full bg-black/50  z-30 js--cart-wrapper"
       @click="closeCart"
       v-if="showCart"
  >
    <div
        class=" max-h-[90vh] overflow-y-scroll max-w-[95%] w-[500px] bg-white  absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 shadow-sm">

      <div class="p-4 relative  pb-10 pt-6">
        <div class="font-title px-3 mb-6 pt-4 pb-3   bg-yellow border border-black text-[28px] leading-none uppercase">
          Cart
        </div>
        <div v-if="loading" class="absolute top-0 left-0 bg-white/80 w-full h-full z-10"></div>
        <div class="pb-2" v-if="lineItems.length === 0">
          Your cart is empty. <button class="underline" @click="showCart = false">Visit the shop</button>.
        </div>
        <div v-else>
          <div v-for="(lineItem, index) in lineItems"
               :class="[index == lineItems.length - 1 ? '' : 'border-b pb-4']"
               class="grid grid-cols-5 gap-x-4 mb-6">
            <div class="col-span-1">
              <img :src="lineItem.variant.image.src" :alt="lineItem.title" class="w-full">
            </div>
            <div class="col-span-4 flex justify-between items-start">
              <div class="h-full flex flex-col justify-between">
                <div>
                  <div class="font-title leading-none font-semibold text-[22px]">{{ lineItem.title }}</div>
                  <div v-if="lineItem.variant.title != 'Default Title'" class="leading-tight text-[14px]">
                    {{ lineItem.variant.title }}
                  </div>
                </div>
                <div class="font-light text-[18px]">{{ formatCurrency.format(lineItem.variant.price.amount) }} <span
                    class="text-[12px]">/ item</span>
                </div>
              </div>
              <div>
                <input type="number" v-model="lineItemsTemp[index]" class="w-12 text-center border">
                <div>
                  <button class="font-sfizia mt-2 text-[12px] hover:underline" @click="removeLineItem(lineItem.id)">
                    Remove
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="mb-4 border-t  pt-4  text-[18px] text-right">
            {{ totalPrice }}
          </div>
          <div class="text-right mt-10">
            <a class="font-title text-[28px] px-[14px] py-[8px] border uppercase transition border-black hover:bg-yellow hover:text-black"
               :href="checkoutUrl">Checkout</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, watch, computed } from 'vue';
import { inject } from 'vue'

const emitter = inject('emitter');   // Inject `emitter`

const lineItems = ref(null);
const checkoutUrl = ref(null);
const totalPrice = ref(null);
console.log('in cart');

// const client = Client.buildClient({
//   domain: "3000-years.myshopify.com",
//   storefrontAccessToken: "3e6fc9a9d297fc85bb5897c679b234ec",
// });

const STOREFRONT_ACCESS_TOKEN = "3e6fc9a9d297fc85bb5897c679b234ec";
const SHOP_DOMAIN = "3000-years.myshopify.com";
const STOREFRONT_API_URL = `https://${SHOP_DOMAIN}/api/2025-07/graphql.json`;

const checkoutId = ref(null);
const loading = ref(false);
const showCart = ref(false);
const lineItemsTemp = ref([]);

// add computed property that calculates the total quantity of the line items by summing quantity for each


const totalQuantity = computed(() => {
  return lineItems.value.reduce((total, item) => {
    return total + item.quantity;
  }, 0);
});


let formatCurrency = new Intl.NumberFormat('en-GB', {
  style: 'currency',
  currency: 'GBP'
});

emitter.on('updateCart', (value) => {   // *Listen* for event
  refreshCart(true);
});

emitter.on('showCart', (value) => {   // *Listen* for event
  showCart.value = true;
});


emitter.on('addToCart', async (data) => {   // *Listen* for event
  console.log('addToCart');
  console.log(data);

  const variantId = `gid://shopify/ProductVariant/${data.variant}`;
  await addToCart(variantId, 1);
  await refreshCart(true);
});

onMounted(() => {
  // refreshCart();
  initializeCart();
});

const refreshCart = async (doShowCart) => {
  try {
    const cart = await fetchCart();
    setUpCart(cart);
    if (doShowCart) {
      showCart.value = true;
    }
  } catch (error) {
    console.error('Error refreshing cart:', error);
  }
}

const setUpCart = (cart, doShowCart) => {
  console.log(cart);
  checkoutId.value = cart.id;
  lineItems.value = JSON.parse(JSON.stringify(cart.lines.edges.map(edge => ({
    id: edge.node.id,
    title: edge.node.merchandise.product.title,
    quantity: edge.node.quantity,
    variant: {
      id: edge.node.merchandise.id,
      title: edge.node.merchandise.title,
      price: {
        amount: edge.node.merchandise.price.amount
      },
      image: {
        src: edge.node.merchandise.image?.url || ''
      }
    }
  }))));
  lineItems.value.forEach((item, index) => {
    lineItemsTemp.value[index] = item.quantity;
  });

  checkoutUrl.value = cart.checkoutUrl;

  totalPrice.value = formatCurrency.format(cart.cost.totalAmount.amount);
  console.log(lineItems.value);
  if (doShowCart) {
    showCart.value = true;
  }
}
const initializeCart = async () => {
  const cartId = localStorage.getItem('shopifyCartId');
  let cart = null;
  if (cartId) {
    try {
      cart = await fetchCart(cartId);
      console.log(cart);
      setUpCart(cart);
    } catch (error) {
      console.error('Error fetching cart:', error);
      cart = await createNewCart();
      setUpCart(cart);
    }
  } else {
    cart = await createNewCart();
    setUpCart(cart);
  }
}

const fetchCart = async (cartId = null) => {
  const id = cartId || localStorage.getItem('shopifyCartId');
  if (!id) return null;

  const query = `
    query cartQuery($cartId: ID!) {
      cart(id: $cartId) {
        id
        checkoutUrl
        cost {
          totalAmount {
            amount
            currencyCode
          }
        }
        lines(first: 100) {
          edges {
            node {
              id
              quantity
              merchandise {
                ... on ProductVariant {
                  id
                  title
                  price {
                    amount
                    currencyCode
                  }
                  image {
                    url
                  }
                  product {
                    title
                  }
                }
              }
            }
          }
        }
      }
    }
  `;

  const response = await fetch(STOREFRONT_API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN,
    },
    body: JSON.stringify({
      query,
      variables: { cartId: id }
    }),
  });

  const data = await response.json();
  return data.data.cart;
};

const createNewCart = async () => {
  const mutation = `
    mutation cartCreate {
      cartCreate {
        cart {
          id
          checkoutUrl
          cost {
            totalAmount {
              amount
              currencyCode
            }
          }
          lines(first: 100) {
            edges {
              node {
                id
                quantity
                merchandise {
                  ... on ProductVariant {
                    id
                    title
                    price {
                      amount
                      currencyCode
                    }
                    image {
                      url
                    }
                    product {
                      title
                    }
                  }
                }
              }
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  `;

  const response = await fetch(STOREFRONT_API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN,
    },
    body: JSON.stringify({ query: mutation }),
  });

  const data = await response.json();
  const newCart = data.data.cartCreate.cart;
  localStorage.setItem('shopifyCartId', newCart.id);
  return newCart;
};

const addToCart = async (variantId, quantity) => {
  const mutation = `
    mutation cartLinesAdd($cartId: ID!, $lines: [CartLineInput!]!) {
      cartLinesAdd(cartId: $cartId, lines: $lines) {
        cart {
          id
          checkoutUrl
          cost {
            totalAmount {
              amount
              currencyCode
            }
          }
          lines(first: 100) {
            edges {
              node {
                id
                quantity
                merchandise {
                  ... on ProductVariant {
                    id
                    title
                    price {
                      amount
                      currencyCode
                    }
                    image {
                      url
                    }
                    product {
                      title
                    }
                  }
                }
              }
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  `;

  const response = await fetch(STOREFRONT_API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN,
    },
    body: JSON.stringify({
      query: mutation,
      variables: {
        cartId: checkoutId.value,
        lines: [{
          merchandiseId: variantId,
          quantity: quantity
        }]
      }
    }),
  });

  const data = await response.json();
  return data.data.cartLinesAdd.cart;
};

const updateCartLines = async (cartId, updates) => {
  const mutation = `
    mutation cartLinesUpdate($cartId: ID!, $lines: [CartLineUpdateInput!]!) {
      cartLinesUpdate(cartId: $cartId, lines: $lines) {
        cart {
          id
          checkoutUrl
          cost {
            totalAmount {
              amount
              currencyCode
            }
          }
          lines(first: 100) {
            edges {
              node {
                id
                quantity
                merchandise {
                  ... on ProductVariant {
                    id
                    title
                    price {
                      amount
                      currencyCode
                    }
                    image {
                      url
                    }
                    product {
                      title
                    }
                  }
                }
              }
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  `;

  const response = await fetch(STOREFRONT_API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN,
    },
    body: JSON.stringify({
      query: mutation,
      variables: {
        cartId: cartId,
        lines: updates
      }
    }),
  });

  const data = await response.json();
  return data.data.cartLinesUpdate.cart;
};

const removeFromCart = async (cartId, lineIds) => {
  const mutation = `
    mutation cartLinesRemove($cartId: ID!, $lineIds: [ID!]!) {
      cartLinesRemove(cartId: $cartId, lineIds: $lineIds) {
        cart {
          id
          checkoutUrl
          cost {
            totalAmount {
              amount
              currencyCode
            }
          }
          lines(first: 100) {
            edges {
              node {
                id
                quantity
                merchandise {
                  ... on ProductVariant {
                    id
                    title
                    price {
                      amount
                      currencyCode
                    }
                    image {
                      url
                    }
                    product {
                      title
                    }
                  }
                }
              }
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  `;

  const response = await fetch(STOREFRONT_API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN,
    },
    body: JSON.stringify({
      query: mutation,
      variables: {
        cartId: cartId,
        lineIds: lineIds
      }
    }),
  });

  const data = await response.json();
  return data.data.cartLinesRemove.cart;
};

watch(lineItemsTemp, async (newLineItems, oldLineItems) => {
  console.log(newLineItems);
  loading.value = true;
  let updates = [];
  console.log(newLineItems);
  console.log(oldLineItems);
  newLineItems.forEach((quantity, index) => {
    console.log(quantity);
    if (oldLineItems) {
      console.log(oldLineItems[index]);
    }
    if (lineItems.value[index] !== undefined) {
      updates.push({
        id: lineItems.value[index].id,
        quantity: quantity
      });
    }
  });

  try {
    const cart = await updateCartLines(checkoutId.value, updates);
    loading.value = false;
    setUpCart(cart);
    console.log(cart.checkoutUrl);
  } catch (error) {
    console.error('Error updating cart:', error);
    loading.value = false;
  }

}, {deep: true});

const closeCart = (target) => {
  if (target.srcElement.classList.contains('js--cart-wrapper')) {
    showCart.value = false;
  }
}
const removeLineItem = async (lineItemId) => {
  console.log('removeLineItem');
  try {
    const cart = await removeFromCart(checkoutId.value, [lineItemId]);
    console.log(cart.lines); // Array with one less line item
    setUpCart(cart, true);
  } catch (error) {
    console.error('Error removing item:', error);
  }
}
</script>